"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsGraph = void 0;
const getPeaksAnnotation_js_1 = require("./getPeaksAnnotation.js");
exports.JsGraph = {
    getPeaksAnnotation: getPeaksAnnotation_js_1.getPeaksAnnotation,
};
//# sourceMappingURL=index.js.map